// src/Header.js
import React from 'react';
import './style.css';
import logo from './logo.png'; // ← Assicurati di avere il logo qui

const Header = () => {
  return (
    <header className="header">
      <div className="header-left">
        <img src={logo} alt="Logo" className="site-logo" />
        <div className="site-info">
        </div>
      </div>
    </header>
  );
};

export default Header;
